import { defineStore } from 'pinia';
import axios from 'axios';

/**
 * Do api call via axios
 * @param {string} street
 * @param {string} street
 * @param {string} housenumber
 * @param {string} postcode
 * @param {string} city
 */
async function apiCall(street, housenumber, postcode, city) {
  const params = new URLSearchParams([
    ['street', street],
    ['houseNumber', housenumber],
    ['postcode', postcode],
    ['city', city],
  ]);
  return axios.get(`${window.app.pnpform.api_base}location.json`, { params });
}
/**
 * Do api call via axios
 * @param {string} id
 */
async function apiCallById(id) {
  return axios.get(`${window.app.pnpform.api_base}location/${id}.json`);
}

export const useLocationStore = defineStore('location', {
  state: () => ({
    locations: [],
    selectedLocation: '',
    selectedLocationId: '',
    userLocation: '',
  }),
  getters: {
    getLocations() {
      return this.locations;
    },
    getSelectedLocation() {
      return this.selectedLocation;
    },
    getSelectedLocationId() {
      return this.selectedLocationId;
    },
  },
  actions: {
    /**
     * Attempt to get location
     * @param {string} street
     * @param {string} housenumber
     * @param {string} postcode
     * @param {string} city
     */
    async getUniqueLocations(street, housenumber, postcode, city) {
      const locationData = await apiCall(street, housenumber, postcode, city);
      const uniqueLocationData = locationData.data.reduce((acc, current) => {
        const x = acc.find((item) => item.number === current.number);
        if (!x) {
          return acc.concat([current]);
        }
        return acc;
      }, []);

      this.$patch({
        locations: uniqueLocationData,
      });
    },
    async getLocationById(id) {
      const locationData = await apiCallById(id);

      this.$patch({
        userLocation: locationData.data,
      });
    },
  },
});
